import React from 'react';
import Imgix from 'react-imgix';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import styled from 'styled-components';
import LeftArrow from '../../../../common/svgs/LeftArrow';
import RightArrow from '../../../../common/svgs/RightArrow';
import { getImgixUrl } from '../../../../utils/helper';

const Wrapper = styled.div`
  max-width: ${({ fabricsLength }) => (fabricsLength ? '1300px' : '1920px')};
  margin: 0px auto;
  padding: 20px 0;
  border-bottom: 1px solid #ececec;

  .slider-container {
    /* max-width: 1250px; */
    max-width: ${({ fabricsLength, checkFabrics }) =>
      checkFabrics(9) ? `calc(140px * ${fabricsLength})` : '1300px'};

    padding: ${({ checkFabrics }) => (checkFabrics(12) ? '0' : '0 45px')};
    margin: ${({ checkFabrics }) => (checkFabrics(12) ? '0' : '0 auto')};

    .slick-next {
      right: -30px;
    }

    .slick-arrow {
      top: 30%;

      svg {
        width: 13px;
        path {
          stroke-width: 3px;
        }
      }
    }

    .slick-track {
      display: flex;

      .slick-slide {
        display: flex;
        height: auto;
        align-items: center;
        justify-content: center;
      }
      .slick-slide > div {
        height: 100%;
        width: 100%;
      }
    }
  }

  @media (max-width: 1300px) {
    .slider-container {
      padding: ${({ checkFabrics }) => (checkFabrics(10) ? '0' : '0 55px')};
      margin: ${({ checkFabrics }) => (checkFabrics(10) ? '0' : '0 auto')};
    }
  }
  @media (max-width: 1000px) {
    .slider-container {
      padding: ${({ checkFabrics }) => (checkFabrics(8) ? '0' : '0 55px')};
      margin: ${({ checkFabrics }) => (checkFabrics(8) ? '0' : '0 auto')};
    }
  }

  @media (max-width: 992px) {
    .slider-container {
      padding: 0 30px;
    }
  }
`;

function FabricSlider({ fabrics, selectedFabric, setSelectedFabric }) {
  const getSliderLength = n => {
    return fabrics.length >= n ? n : fabrics.length;
  };

  const checkFabrics = n => {
    return n > fabrics.length;
  };

  const settings = {
    className: 'slides',
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: getSliderLength(12),
    slidesToScroll: getSliderLength(12),
    initialSlide: 0,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: getSliderLength(12),
          slidesToScroll: getSliderLength(12),
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: getSliderLength(10),
          slidesToScroll: getSliderLength(10)
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: getSliderLength(8),
          slidesToScroll: getSliderLength(8)
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: getSliderLength(7),
          slidesToScroll: getSliderLength(7)
        }
      },
      {
        breakpoint: 660,
        settings: {
          slidesToShow: getSliderLength(5),
          slidesToScroll: getSliderLength(5)
        }
      },
      {
        breakpoint: 530,
        settings: {
          slidesToShow: getSliderLength(3),
          slidesToScroll: getSliderLength(3)
        }
      }
    ]
  };

  return (
    <Wrapper checkFabrics={checkFabrics} fabricsLength={fabrics.length}>
      <div className="slider-container">
        <Slider {...settings}>
          {fabrics.map(fabric => {
            const fabricFullName = `${fabric.name}${
              fabric?.collaborator ? ` by ${fabric?.collaborator?.name}` : ''
            }`;

            return (
              <Fabric
                key={fabric.id}
                selected={parseInt(fabric.id) === parseInt(selectedFabric?.id)}
              >
                <div
                  title={fabricFullName}
                  onClick={() => setSelectedFabric(fabric)}
                  className="fabric-image-container"
                >
                  <Imgix
                    sizes="200px"
                    src={getImgixUrl(fabric.image)}
                    imgixParams={{
                      auto: 'compress,format'
                    }}
                    htmlAttributes={{
                      alt: fabric.name,
                      loading: 'lazy'
                    }}
                  />
                </div>
              </Fabric>
            );
          })}
        </Slider>
      </div>
    </Wrapper>
  );
}

export default FabricSlider;

const Fabric = styled.div`
  outline: none;
  display: flex !important;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 100%;
  position: relative;

  .fabric-image-container {
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;

    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      border: ${({ theme, selected }) => (selected ? `3px solid ${theme.colors.french}` : 'none')};
      border-radius: ${({ selected }) => (selected ? '3px' : 'none')};
      max-width: 90px;
      height: auto;
    }
  }

  @media (max-width: 992px) {
    .fabric-image-container {
      img {
        width: 90px;
        height: auto;
      }
    }
  }
`;

const PrevArrow = props => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <LeftArrow />
    </div>
  );
};

const NextArrow = props => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <RightArrow />
    </div>
  );
};
